import ensureMapsRobotoFontDisplay from './ensureMapsRobotoFontDisplay';

/**
 * Warm Maps origins only when Maps/Places is about to load.
 * Avoids competing with landing-page LCP for connection slots.
 */
export default function ensureMapsPreconnect() {
  if (typeof document === 'undefined') return;

  // Maps injects Roboto without font-display; force swap before that request.
  ensureMapsRobotoFontDisplay();

  if (document.querySelector('link[data-maps-preconnect]')) return;

  const mapsApi = document.createElement('link');
  mapsApi.rel = 'preconnect';
  mapsApi.href = 'https://maps.googleapis.com';
  mapsApi.setAttribute('data-maps-preconnect', 'true');
  document.head.appendChild(mapsApi);

  const mapsStatic = document.createElement('link');
  mapsStatic.rel = 'preconnect';
  mapsStatic.href = 'https://maps.gstatic.com';
  mapsStatic.crossOrigin = 'anonymous';
  mapsStatic.setAttribute('data-maps-preconnect', 'true');
  document.head.appendChild(mapsStatic);
}
